import { render, staticRenderFns } from "./ThaiLottoDetail.vue?vue&type=template&id=9d2d9b2e"
import script from "./ThaiLottoDetail.vue?vue&type=script&lang=js"
export * from "./ThaiLottoDetail.vue?vue&type=script&lang=js"
import style0 from "./ThaiLottoDetail.vue?vue&type=style&index=0&id=9d2d9b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports